module.exports = __webpack_public_path__ + "img/foot-print.11fd8873.svg";